import { ComplianceDTO } from "../../interfaces/compliance"
import { ResponseDTO } from "../../interfaces/response"
import { formatDate_ddMMYY } from "../function/function-generic"
import { ComplianceServices } from "../services/ComplianceServices"

interface IComplianceService {
    getComplianceallByBusiness(dataBody: any): Promise<ResponseDTO>;
    getComplianceDetailsByid(id: number): Promise<ResponseDTO>;
    postComplianceDownload(dataBody: any): Promise<ResponseDTO>;
}
export class ComplianceController implements IComplianceService {

    public complianceServices = new ComplianceServices()

    public async getComplianceallByBusiness(dataBody: any): Promise<ResponseDTO> {
        const response = await this.complianceServices.getComplianceallByBusiness(dataBody)
        return response
    }

    public async getComplianceDetailsByid(id: number): Promise<ResponseDTO> {
        return await this.complianceServices.getComplianceDetailsByid(id)
    }

    public async mapRowDataCompliance(data: any): Promise<ComplianceDTO[]> {
        const result: ComplianceDTO[] = await data.map((res: ComplianceDTO) => (
            {
                ...res,
                date: formatDate_ddMMYY(String(new Date(res.date)))
            }
        ))
        return result
    }

    public async postComplianceDownload(dataBody: any): Promise<ResponseDTO> {
        return await this.complianceServices.postComplianceDownload(dataBody)
    }
}